var map = {
	"./advertising.vue": "a6ce",
	"./brochure-information.vue": "201a",
	"./business-profile.vue": "16c5",
	"./cadre-education.vue": "1b65",
	"./dispatch-outsourcing.vue": "d311",
	"./educational-orientation.vue": "25c5",
	"./evaluation.vue": "f671",
	"./field-teaching-base.vue": "87f0",
	"./foundation.vue": "9c9c",
	"./group-profile.vue": "f0e6",
	"./high-end-talents.vue": "c35d",
	"./information-disclosure.vue": "f8e9",
	"./management-consulting.vue": "ec28",
	"./organizational-structure.vue": "0a2b",
	"./park-operation.vue": "effd",
	"./personnel-training.vue": "f913",
	"./product-system.vue": "dfeb",
	"./talent-recruitment.vue": "a889",
	"./training-policy.vue": "8264",
	"./training-program.vue": "6a55"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0fe2";